import { queryOptions } from '@tanstack/react-query'
import type { CategoryQuery } from '@/types/category'
import type { ProductQuery } from '@/types/product'
import type { ChartOrderQuery } from '@/types/dashboard'
import { CategoryService } from '@/services/category'
import { ProductService } from '@/services/products'
import { ProductApisService } from '@/services/product-apis'
import { PromotionService } from '@/services/promotion'
import { DashboardService } from '@/services/dashboard'

export const categoryQueryOptions = (query?: CategoryQuery) =>
  queryOptions({
    queryKey: ['categories', query],
    queryFn: () => CategoryService.getList(query),
    refetchOnWindowFocus: false,
  })

export const subCategoryQueryOptions = (query: CategoryQuery) =>
  queryOptions({
    queryKey: ['sub-categories', query],
    queryFn: () => CategoryService.getList(query),
    enabled: !!query.parentId,
    refetchOnWindowFocus: false,
  })

export const productQueryOptions = (query: ProductQuery) =>
  queryOptions({
    queryKey: ['products', query],
    queryFn: () => ProductService.getList(query),
    refetchOnWindowFocus: false,
  })

export const productApisQueryOptions = () =>
  queryOptions({
    queryKey: ['product-apis'],
    queryFn: () =>
      ProductApisService.list({ page: 1, take: 100, isSelectAll: true }),
    refetchOnWindowFocus: false,
  })

export const productDetailQueryOptions = (productId: string) =>
  queryOptions({
    queryKey: ['product', productId],
    queryFn: () => ProductService.getDetail(productId),
    refetchOnWindowFocus: false,
    enabled: !!productId,
  })

export const promotionDetailQueryOptions = (promotionId: string) =>
  queryOptions({
    queryKey: ['promotion', promotionId],
    queryFn: () => PromotionService.getById(promotionId),
    refetchOnWindowFocus: false,
    enabled: !!promotionId,
  })

export const overviewQueryOptions = (currency: 'vnd' | 'usd') =>
  queryOptions({
    queryKey: ['dashboard', 'overview', currency],
    queryFn: () => DashboardService.getOverview(currency),
    refetchOnWindowFocus: false,
  })

export const orderChartQueryOptions = (params: ChartOrderQuery) =>
  queryOptions({
    queryKey: ['dashboard', 'orders-chart', params],
    queryFn: () => DashboardService.getOverviewOrderChart(params),
    refetchOnWindowFocus: false,
  })

export const topUpOverviewChartQueryOptions = (params: ChartOrderQuery) =>
  queryOptions({
    queryKey: ['dashboard', 'top-up-overview-chart', params],
    queryFn: () => DashboardService.getOverviewTopUpChart(params),
    refetchOnWindowFocus: false,
  })
